
export const profileCategories = [
    {label: 'martyr', value: 'is_martyr'},
    {label: 'is holy doctor', value: 'is_holy_doctor'},
    {label: 'saint', value: 'is_saint'},
    {label: 'prelates', value: 'is_prelate'},
    {label: 'Philosopher', value: 'is_philosopher'},
    {label: 'Theologian', value: 'is_theologian'},
    {label: 'Musician', value: 'is_musician'},
    {label: 'Lay Person', value: 'is_lay_person'},
    {label: 'Scientist', value: 'is_scientist'},
];

